import React from 'react';
import PropTypes from 'prop-types';

import { faFileCircleExclamation } from '@fortawesome/pro-regular-svg-icons';

import EmptyState from 'shared/empty_state';
import { download } from 'components/file_system/helpers';

export default function NoPreview({ file }) {
  return (
    <EmptyState
      bodyText="Please click download to view"
      buttonText="Download"
      header="This file can't be previewed"
      icon={faFileCircleExclamation}
      onButtonClick={() => download(file)}
    />
  );
}

NoPreview.propTypes = {
  file: PropTypes.shape({
    downloadUrl: PropTypes.string,
    fileName: PropTypes.string,
    url: PropTypes.string
  })
};
